import { render } from "./VideoAnalytics.vue?vue&type=template&id=0433be99&scoped=true"
import script from "./VideoAnalytics.vue?vue&type=script&lang=js"
export * from "./VideoAnalytics.vue?vue&type=script&lang=js"

import "./VideoAnalytics.vue?vue&type=style&index=0&id=0433be99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0433be99"]])

export default __exports__